/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { literal } from '../../util.type';

export default {
  name: literal('layer'),
  methods: {
    toString() {
      return `Layer {id: "${this.id}", parentLayoutId: "${this.parentLayoutId}"}`;
    }
  },
  relations: {
    belongsTo: {
      // TODO #458: Vnitřní šablony nejsou zatím podporované
      // layout: {
      //   localField: 'layout',
      //   localKey: 'layoutId'
      // },
      medium: {
        localField: 'medium',
        localKey: 'mediumId'
      },
      playlist: {
        localField: 'playlist',
        localKey: 'playlistId'
      }
    }
  }
};
